import React from 'react';

function isSourceMapError(error) {
  const msg = error?.message || String(error || '');
  return msg.includes('.map') || msg.toLowerCase().includes('sourcemap');
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Suppress source map 404 cascade (dev-only noise)
    if (isSourceMapError(error)) {
      return null;
    }
    return { hasError: true, error };
  }

  componentDidUpdate(prevProps) {
    if (this.props.resetKey !== prevProps.resetKey) {
      this.setState({ hasError: false, error: null });
    }
  }

  componentDidCatch(error, info) {
    if (isSourceMapError(error)) return;
    console.error(`[ErrorBoundary${this.props.name ? ` (${this.props.name})` : ''}]`, error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError && this.state.error) {
      const { fallback } = this.props;
      if (typeof fallback === 'function') {
        return fallback(this.state.error, this.handleRetry);
      }
      if (fallback) {
        return fallback;
      }

      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', height: '100%', minHeight: 200,
          gap: '1rem', color: 'var(--text-secondary, #888)',
        }}>
          <p>Something went wrong{this.props.name ? ` in ${this.props.name}` : ''}.</p>
          <button
            onClick={this.handleRetry}
            style={{
              padding: '0.5rem 1rem', borderRadius: 6,
              border: '1px solid var(--border-color, #333)',
              background: 'var(--bg-secondary, #1a1e26)',
              color: 'var(--text-primary, #fff)', cursor: 'pointer',
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
